import { createSelector } from '@ngrx/store';

import { locationsFiltersState } from '../root';

export const getLocationFiltersSearchInput = createSelector(locationsFiltersState, (locationsFilters) => locationsFilters?.search || null);
